//react
import { useContext,useState,useEffect } from 'react';
//css
import "../index.css";
import "./label.css";
//constext
import NoteContext from '../../../context/NoteContext';
import {getLabelNote,getPriority,getdate,getSearchCart,getpin} from '../utility/filterutility';
import {Modal_EditTag} from "../../../component/Modal/Modal"
//component
import {Card } from '../../../component/Card/Card';
import SetLabel from './setlabel';
import Filter from '../../../component/Filter/Filter'


const Note_Label = () =>{
    const {noteItems,handle_editNote,filter,handle_AddTag,handle_DeleteTag,tagList} = useContext(NoteContext);
    //function
    const LabelNote = getLabelNote( noteItems,filter.isChecked);
    const PriorityNote = getPriority(LabelNote,filter.priority);
    const SortBydateNote = getdate(PriorityNote,filter.sortdate);
    const SortBypin = getpin(SortBydateNote,filter.sortpin)
    const SearchByTitle = getSearchCart(SortBypin,filter.search);
    //state
    const [addtag,setaddtag]=useState("")
    const[openeditmodal,setopeneditmodal] = useState(false)
    const[dataedit,setdataedit]=useState("")
    //
    useEffect(()=>{
        window.scrollTo({ behavior: 'smooth', top: '0px' });
    },[])

    const handleSubmitAddtag=(e)=>{
        e.preventDefault(); 
        if(addtag.trim()!==""){
            let check = tagList.length>0 &&   tagList.find(i=>i.name===addtag.trim())
            if(check){
                alert("name already added")
            }else{
                let data ={
                    id:Math.random(),
                    name:addtag.trim()
                }
                handle_AddTag(data)
                setaddtag("")
                
            }

        }else{
            alert("text is empty")
        }
    }

    return(
            // <div className='flex-col flex-justify-content-center flex-align-item-center row-gap-1rem typology-padding-top'>
            <div className='typology-padding-top'>
                <form onSubmit={(e)=>{handleSubmitAddtag(e)}}> 
                    <input className='input-tag' placeholder='add tag...' value={addtag} onChange={(e)=>setaddtag(e.target.value)} required/> 
                    <button type='submit' className='button-outline-primary button-onhover-fillbackground'> Add Tag </button>
                </form>
                      {
                        tagList.length>0 ?
                        <div className='flex-row col-gap-2rem row-gap-2rem filter-box typology-padding-top'>
                             {
                                tagList.map((item,index)=>{
                                    return(
                                        <div key={index} className="tag-list-container">
                                            <label> {item.name} </label> 
                                            <div className='tag-list-button'>
                                                 <i className="material-icons curser-pointer icon-note-hover " onClick={()=>{setdataedit(item);setopeneditmodal(!openeditmodal)}}> edit </i>
                                                 <i className="material-icons curser-pointer icon-note-hover " onClick={()=>{handle_DeleteTag(item)}}> delete </i>
                                            </div>
                                        </div>
                                    )
                                })
                             }
                        </div> :
                         <div className='flex-row col-gap-2rem filter-box typology-padding-top'>
                             No Tag Added
                         </div>
                      }
               
                {/* <div className='flex-col row-gap-2rem filter-box'>
                    <Filter data={SearchByTitle} originaldata={noteItems}/> 
                </div>

                {SearchByTitle.length>0?<h3> Assign Label to Note </h3>:<h3> No item found in Label list</h3>}
                <div className='grid-note-cart'> 
                {SearchByTitle.length>0 && SearchByTitle.map((item,index)=>{      
                    return(
                            <div className='flex-col row-gap-1rem typography-padding-5px' key={index}>
                                <SetLabel note={item} index={index} />
                                <Card data={item}/>
                                <br/> 
                            </div>
                    )   
                })}
            </div> */}

           {openeditmodal? <Modal_EditTag data={dataedit} modalClose={()=>setopeneditmodal(false)} /> :null}
        </div>
    )
} 

export default Note_Label